import React from "react";
import dwlLogo from "../../images/dwl_logo_login.png";

const DefaultSearchLogo = ({ rate, onChangeRate }) => {
  return (
    <>
      <div className="search-logo">
        <img
          src={dwlLogo}
          alt="dwl logo"
          className="img-fluid dwl-login-logo"
        />
      </div>
      <div className="dwl-rates-text">Dwellworks Living Market Rates</div>
    </>
  );
};

export default DefaultSearchLogo;
